import InvoiceDetailPart from "../Fields/InvoiceDetailPart";
import InvoiceDetailColumn, { IInvoiceLevelProps } from "./InvoiceDetailColumn";
import { IInvoiceDetail } from "models/IOrder";

export default class InvoiceDetailPartColumn extends InvoiceDetailColumn {

    public constructor(columnName: string, headerText: string, width: string) {
        super(columnName, headerText, width);
        this.align = "left";
    }

    public CellContent(props: IInvoiceLevelProps, invoiceDetail: IInvoiceDetail): JSX.Element {

        return <InvoiceDetailPart
            invoiceDetail={invoiceDetail}
            variant="body2"
        />
    }

    public FooterContent(invoiceProps: IInvoiceLevelProps): JSX.Element {
        return <></>;
    }
}
